import React, { Component } from "react";
import { withRouter } from "./withRouter";
import mapboxgl from "mapbox-gl";
import { tableFromIPC } from "apache-arrow";
import { Typography,Box, Stack, Select, Avatar,TextField,
    FormControl, InputLabel, MenuItem
 } from "@mui/material";
import MapComponent from "./MapComponent"
import ScatterDemogsChart from "./ScatterDemogsChart"

import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid, Cell } from "recharts";



  // Nice tooltip (like your screenshot)
const IssueTooltip = ({ active, payload }) => {
  if (!active || !payload?.length) return null;

  const d = payload[0].payload;
  const value = Number(d.value);

  return (
    <div
      style={{
        background: "#fff",
        border: "1px solid #e5e7eb",
        borderRadius: 8,
        padding: "10px 12px",
        boxShadow: "0 6px 18px rgba(0,0,0,0.12)",
        minWidth: 140,
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <span
          style={{
            width: 10,
            height: 10,
            borderRadius: 999,
            background: d.color,
            display: "inline-block",
          }}
        />
        <div style={{ fontWeight: 700 }}>{d.shortName}</div>
      </div>

      <div style={{ marginTop: 6, fontSize: 20, fontWeight: 800 }}>
        {Number.isFinite(value) ? `${value.toFixed(1)}%` : "—"}
      </div>
    </div>
  );
};
export function getIssueKeys(issueLevel) {
  // Default to national if anything unexpected comes through
  const level = issueLevel === "local" ? "local" : "national";

  if (level === "national") {
    return [
      "health_nat_p",
      "climate_nat_p",
      "nitrogen_nat_p",
      "housing_nat_p",
      "immigration_nat_p",
      "poverty_nat_p",
      "purchasing_nat_p",
      "safety_nat_p",
      "education_nat_p",
      "dutch_nat_p",
      "trust_nat_p",
      "defense_nat_p",
      "EU_nat_p",
      "staff_nat_p",
     // "other_nat_p",
    ];
  }

  return [
    "housing_local_p",
    "CoL_local_p",
    "traffic_local_p",
    "publicTransport_local_p",
    "safety_local_p",
    "health_local_p",
    "recycle_local_p",
    "education_local_p",
    "climate_local_p",
    "econ_local_p",
    "governance_local_p",
    "integration_local_p",
    //"other_local_p",
  ];
}


export function baseColorForLikertKey(group, key) {
  const pol = group.polarity || {};
  // Find which polarity (pos/neg/neu) corresponds to this key
  const tag = Object.entries(pol).find(([polarity, polKey]) => polKey === key)?.[0];

  
  if (tag === "pos") return "#2E7D32";
  if (tag === "neg") return "#C62828";
  return "#6e6e6e";
}
const rowsFromTable = (table) => {
  const cols = table.schema.fields.map(f => f.name);
  const rows = [];
  for (let i = 0; i < table.numRows; i++) {
    const obj = {};
    for (const c of cols) obj[c] = table.getChild(c).get(i);
    rows.push(obj);
  }
  return rows;
};

// Define party full names and official colours
// Define party full names and official colours
export const ISSUE_INFO = {
  // National
  health_nat_p: { name: "Health (national)", color: "#1976d2" },
  climate_nat_p: { name: "Climate (national)", color: "#2e7d32" },
  nitrogen_nat_p: { name: "Nitrogen (national)", color: "#6d4c41" },
  housing_nat_p: { name: "Housing (national)", color: "#7b1fa2" },
  immigration_nat_p: { name: "Immigration (national)", color: "#f57c00" },
  poverty_nat_p: { name: "Poverty (national)", color: "#d32f2f" },
  purchasing_nat_p: { name: "Purchasing power (national)", color: "#c2185b" },
  safety_nat_p: { name: "Safety (national)", color: "#455a64" },
  education_nat_p: { name: "Education (national)", color: "#512da8" },
  dutch_nat_p: { name: "Dutch identity/language (national)", color: "#0288d1" },
  trust_nat_p: { name: "Trust in politics (national)", color: "#5d4037" },
  defense_nat_p: { name: "Defence (national)", color: "#37474f" },
  EU_nat_p: { name: "EU (national)", color: "#1565c0" },
  staff_nat_p: { name: "Staffing (national)", color: "#00838f" },
  other_nat_p: { name: "Other (national)", color: "#9e9e9e" },

  // Local
  housing_local_p: { name: "Housing (local)", color: "#7b1fa2" },
  CoL_local_p: { name: "Cost of living (local)", color: "#c2185b" },
  traffic_local_p: { name: "Traffic (local)", color: "#455a64" },
  publicTransport_local_p: { name: "Public transport (local)", color: "#00838f" },
  safety_local_p: { name: "Safety (local)", color: "#455a64" },
  health_local_p: { name: "Health (local)", color: "#1976d2" },
  recycle_local_p: { name: "Recycling/waste (local)", color: "#2e7d32" },
  education_local_p: { name: "Education (local)", color: "#512da8" },
  climate_local_p: { name: "Climate (local)", color: "#2e7d32" },
  econ_local_p: { name: "Local economy (local)", color: "#6d4c41" },
  governance_local_p: { name: "Local governance (local)", color: "#5d4037" },
  integration_local_p: { name: "Integration (local)", color: "#f57c00" },
  other_local_p: { name: "Other (local)", color: "#9e9e9e" },
};



// Build labels and colors in one go
const buildLabelsAndColors = () => {
  const labels = {};
  const colors = {};

  Object.entries(ISSUE_INFO).forEach(([key, info]) => {
    labels[key] = info.name;
    colors[key] = info.color;
  });

  return { labels, colors };
};


const clamp01 = (x) => Math.max(0, Math.min(1, x));
const hexToHsl = (hex) => {
  let c = hex.replace("#",""); if (c.length===3) c = c.split("").map(x=>x+x).join("");
  const r=parseInt(c.slice(0,2),16)/255, g=parseInt(c.slice(2,4),16)/255, b=parseInt(c.slice(4,6),16)/255;
  const max=Math.max(r,g,b), min=Math.min(r,g,b); let h,s,l=(max+min)/2;
  if(max===min){h=s=0;} else {const d=max-min; s=l>0.5?d/(2-max-min):d/(max+min);
    switch(max){
    case r:h=(g-b)/d+(g<b?6:0);
      break;
    case g:h=(b-r)/d+2;
      break;
    case b:h=(r-g)/d+4;
      break;
    default:
      break;
    } h/=6;}
  return {h:Math.round(h*360), s:Math.round(s*100), l:Math.round(l*100)};
};
const hslToHex = (h,s,l) => {
  h/=360; s/=100; l/=100;
  const hue2rgb=(p,q,t)=>{ if(t<0)t+=1;if(t>1)t-=1;if(t<1/6)return p+(q-p)*6*t;if(t<1/2)return q;if(t<2/3)return p+(q-p)*(2/3-t)*6;return p; };
  const q=l<0.5?l*(1+s):l+s-l*s; const p=2*l-q;
  const r=Math.round(hue2rgb(p,q,h+1/3)*255), g=Math.round(hue2rgb(p,q,h)*255), b=Math.round(hue2rgb(p,q,h-1/3)*255);
  return "#"+[r,g,b].map(v=>v.toString(16).padStart(2,"0")).join("");
};
const clamp = (x, lo, hi) => Math.min(hi, Math.max(lo, x));
const clamp02 = (x) => clamp(x, 0, 1);

function lowerBound(arr, x) {
  // first index i where arr[i] >= x
  let lo = 0, hi = arr.length;
  while (lo < hi) {
    const mid = (lo + hi) >> 1;
    if (arr[mid] < x) lo = mid + 1;
    else hi = mid;
  }
  return lo;
}

const makeHeatScale = (
  baseHex,
  values,
  {
    qLow = 0.01,          // trim tails (outliers)
    qHigh = 0.99,
    lightMin = 40,
    lightMax = 95,
    gamma = 0.85,          // 1 = linear in percentile space
    missing = "#CCCCCC",
    minSat = 35,
    neutralSatCutoff = 6, // keep greys grey
  } = {}
) => {
  const finite = values.filter(Number.isFinite).slice().sort((a, b) => a - b);
  const n = finite.length;
  if (!n) return () => missing;

  const { h, s } = hexToHsl(baseHex);
  const sat = s <= neutralSatCutoff ? 0 : Math.max(s, minSat);

  // Precompute indices for trimming (winsorising in percentile space)
  const loIdx = Math.floor((n - 1) * qLow);
  const hiIdx = Math.floor((n - 1) * qHigh);
  const denom = Math.max(1, hiIdx - loIdx);

  return (v) => {
    if (!Number.isFinite(v)) return missing;

    // percentile rank via binary search
    const idx = lowerBound(finite, v);

    // trim tails to avoid outliers dominating colour range
    const clippedIdx = clamp(idx, loIdx, hiIdx);

    // continuous position within the trimmed range
    let t = (clippedIdx - loIdx) / denom;
    t = Math.pow(clamp02(t), gamma);

    const light = lightMax - t * (lightMax - lightMin);
    return hslToHex(h, sat, light);
  };
};


const make2pointHeatScale = (baseHexPos, baseHexNeg, values) => {
  const finite = values.filter(v => Number.isFinite(v));
  const min = finite.length ? Math.min(...finite) : 0;
  const max = finite.length ? Math.max(...finite) : 100;

  return (v) => {
    if (!Number.isFinite(v)) return "#CCCCCC";

    if (v >= 0) {
      // Positive side
      const { h, s } = hexToHsl(baseHexPos);
      const t = clamp01(v / Math.max(1e-6, max)); // normalise 0 → max
      const light = 95 - t * 60;
      return hslToHex(h, s, light);
    } else {
      // Negative side
      const { h, s } = hexToHsl(baseHexNeg);
      const t = clamp01(v / Math.min(-1e-6, min)); // normalise 0 → min (negative)
      const light = 95 - t * 60;
      return hslToHex(h, s, light);
    }
  };
};



class NZ2026SeatComparisonIssues extends Component {
      constructor(props) {
    super(props);
    this.state = {
      geoLevel: "geementen",
      metricRows: null, 
      loading: false,
      hoverInfo: null,
      hoverAreaId: null,
      selectedStateBounds: null,
      selectedFeature: null,   
      geoData:props.GEEMENTENMap,
      styleLoaded: false,
      viewState: null,
      metricRowsConst: null,
      metricRowsNational:null,
      chosenParty:"top",
      chosenView:"pred",
      scatterDemogsRows:null,
      IssueLevel:"national"
    };
    
    this.mapRef = React.createRef();
    this._inflight = null; 
    this._lastKey = null;
    this._lastAt = 0;

    
  }

  
  componentDidMount() {
  const run = async () => {
    await this.fetchMetrics("national", null, true);
    await this.fetchMetrics("geementen", null, true);
  };
  run();
}

   componentDidUpdate(prevProps, prevState) {
    const groupChanged      = prevProps.selectedGroupId !== this.props.selectedGroupId;
   
    const levelChanged      = prevState.geoLevel !== this.state.geoLevel;

    const chosenPartychange = prevState.chosenParty !== this.state.chosenParty;
    const chosenViewchange = prevState.chosenView !== this.state.chosenView;
    const IssueLevelChanged      = prevState.IssueLevel !== this.state.IssueLevel;

  
    const needRefetch = levelChanged  || groupChanged ;
    if (needRefetch) {
      this.fetchMetrics(this.state.geoLevel, this.state.selectedFeature?.area_id);
    }

  
    const rowsChanged  = prevState.metricRows !== this.state.metricRows;
    const geoChanged   = prevState.geoData !== this.state.geoData;
  
    if (geoChanged || rowsChanged || groupChanged || chosenPartychange ||chosenViewchange||IssueLevelChanged) {
      this.restyle();
    }
  
   
    
  }
  _inflightBaseline = null;
  _lastBaselineKey = null;
  _lastBaselineAt = 0;
    requestKey = (level) => {

    return `${level}`;
  };


  //main function that grabs data
    fetchMetrics = async (level, constCode, save_const_results) => {
  const controller = new AbortController(); // new controller for this call
  const signal = controller.signal;

  const reqKey = this.requestKey(level);
  const now = Date.now();
  if (this._lastKey === reqKey && now - this._lastAt < 700) return;
  this._lastKey = reqKey;
  this._lastAt = now;


    let keysBody 
    if(level==="national"){
          keysBody= [   "health_nat_p",
            "climate_nat_p",
            "nitrogen_nat_p",
            "housing_nat_p",
            "immigration_nat_p", 
            "poverty_nat_p",
            "purchasing_nat_p",
            "safety_nat_p",
            "education_nat_p",
            "dutch_nat_p",
            "trust_nat_p",
            "defense_nat_p",
            "EU_nat_p",
            "staff_nat_p",
            "other_nat_p",
            "housing_local_p",
            "CoL_local_p",
            "traffic_local_p",
            "publicTransport_local_p",
            "safety_local_p",
            "health_local_p",
            "recycle_local_p",
            "education_local_p",
            "climate_local_p",
            "econ_local_p",
            "governance_local_p",
            "integration_local_p",
            "other_local_p",
            

                  ]  
    }else{
    keysBody= [   "health_nat_p",
            "climate_nat_p",
            "nitrogen_nat_p",
            "housing_nat_p",
            "immigration_nat_p", 
            "poverty_nat_p",
            "purchasing_nat_p",
            "safety_nat_p",
            "education_nat_p",
            "dutch_nat_p",
            "trust_nat_p",
            "defense_nat_p",
            "EU_nat_p",
            "staff_nat_p",
            "other_nat_p",
            "housing_local_p",
            "CoL_local_p",
            "traffic_local_p",
            "publicTransport_local_p",
            "safety_local_p",
            "health_local_p",
            "recycle_local_p",
            "education_local_p",
            "climate_local_p",
            "econ_local_p",
            "governance_local_p",
            "integration_local_p",
            "other_local_p",

                  ]
                }
                
     let turnout_weight
    turnout_weight = "turnout_GE_n"

    const body = {
      groupKeys: keysBody,
      filters:[],
      constCode: constCode,
      turnout_weight:turnout_weight
    };
  
    this.setState({ loading: true });
  

 
    try {
      // --- call main metrics endpoint ---
          const resMain = await fetch(`/api/${level}_data_arrow/`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(body),
                signal,
                });
      if (!resMain.ok) throw new Error(`metrics fetch ${resMain.status}`);
      const bufMain = await resMain.arrayBuffer();
      const tableMain = tableFromIPC(bufMain);
      const rowsMain = rowsFromTable(tableMain);
      // --- update state with both ---
      if(save_const_results){
        if(level==="national"){
          this.setState(
             { metricRowsNational: rowsMain })
            }else{
            this.setState(
            { metricRowsConst: rowsMain ,
                metricRows: rowsMain,})
            }
      }else{
           this.setState({
        metricRows: rowsMain,
        loading: false,
        
      });
      }
   
    } catch (e) {
      if (e.name !== "AbortError") console.error("metrics error:", e);
      this.setState({ metricRows: null,  loading: false });
    } finally {
      this._inflight = null;
    }

  }



  
  getValueAndCI(row, key) {
  const value = Number(row?.[key]);
  const lower = Number(row?.[`${key}_lower`]);
  const upper = Number(row?.[`${key}_upper`]);

  return {
    value,
    lower: Number.isFinite(lower) ? lower : undefined,
    upper: Number.isFinite(upper) ? upper : undefined,
  };
}


restyle = () => {
  const { geoData, metricRows, IssueLevel } = this.state;

  if (!geoData) {
    this.setState({ styledGeo: null });
    return;
  }
  if (!metricRows) return;

  const byId = new Map();
  for (const r of metricRows) {
    const id = String(r.area_id ?? "");
    if (id) byId.set(id, r);
  }

  const { labels } = buildLabelsAndColors();

  const heatKey = this.state.chosenParty; // can be "top" or a specific issue key
  const isTop = heatKey === "top";

  // Only build a heatScale when we're NOT in "top" mode
  let heatScale = null;

  if (!isTop) {
    const values = geoData.features.map((f) => {
      const rid = String(f.properties?.area_id ?? "");
      const row = byId.get(rid);
      if (!row) return NaN;

      if (this.state.chosenView === "pred") {
        return Number(row[heatKey]);
      } else {
        // existing change logic (party-style baseline). Kept as-is.
        let pastKey;

        pastKey = heatKey
          .replace("_GE_p", "")
          .replace("_LE_p", "")
          .replace("past_vote_", "");

        pastKey = pastKey === "turnout" ? "past_turnout" : pastKey;

        const past = Number(f.properties?.[pastKey]) * 100;
        return Number(row[heatKey]) - past;
      }
    });

    const base = ISSUE_INFO[heatKey]?.color || "#6e6e6e";

    heatScale =
      this.state.chosenView === "change"
        ? make2pointHeatScale("#2E7D32", "#C62828", values)
        : makeHeatScale(base, values);
  }

  const styled = {
    type: "FeatureCollection",
    features: geoData.features.map((f) => {
      const rid = String(f.properties?.area_id ?? "");
      const row = byId.get(rid);

      if (!row) {
        return {
          ...f,
          properties: {
            ...f.properties,
            fillColor: "#ffffff",
            topLabel: "No data",
            topValue: 0,
            topLower: undefined,
            topUpper: undefined,
            _allValues: {},
            _allValuesSorted: [],
          },
        };
      }

      const groupKeys = getIssueKeys(IssueLevel);
      const displayKeys = (groupKeys || []).filter((k) => k in row);

      if (displayKeys.length === 0) {
        return {
          ...f,
          properties: {
            ...f.properties,
            fillColor: "#ffffff",
            topLabel: "No data",
            topValue: 0,
            topLower: undefined,
            topUpper: undefined,
            _allValues: {},
            _allValuesSorted: [],
          },
        };
      }

      // entries WITH CI (sorted by predicted value desc)
      const entries = displayKeys
        .map((k) => {
          const { value, lower, upper } = this.getValueAndCI(row, k);
          return {
            key: k,
            area_name: labels[k] || k,
            value,
            lower,
            upper,
          };
        })
        .filter((e) => Number.isFinite(e.value))
        .sort((a, b) => b.value - a.value);

      if (entries.length === 0) {
        return {
          ...f,
          properties: {
            ...f.properties,
            fillColor: "#ffffff",
            topLabel: "No data",
            topValue: 0,
            topLower: undefined,
            topUpper: undefined,
            _allValues: {},
            _allValuesSorted: [],
          },
        };
      }

      // If "top", we colour by the winner key for this area
      const resolvedHeatKey = isTop ? entries[0].key : heatKey;

      // value used for colouring / topValue depends on chosenView
      let v;
      let baseline = undefined;

      if (this.state.chosenView === "pred") {
        v = isTop ? entries[0].value : Number(row[resolvedHeatKey]);
      } else {
        // existing change logic (party-style baseline). Kept as-is.
        let pastKey;

        pastKey = resolvedHeatKey
          .replace("_GE_p", "")
          .replace("_LE_p", "")
          .replace("past_vote_", "");

        pastKey = pastKey === "turnout" ? "past_turnout" : pastKey;

        baseline = Number(f.properties?.[pastKey]) * 100;
        v = Number(row[resolvedHeatKey]) - baseline;
      }

      // === HERE'S THE KEY CHANGE ===
      // If "top": use the base colour for the winning key, no heat shading
      const fillColor = isTop
        ? (ISSUE_INFO[resolvedHeatKey]?.color || "#6e6e6e")
        : heatScale?.(v);

      // CI for the selected key (resolvedHeatKey)
      const heatCI = this.getValueAndCI(row, resolvedHeatKey);

      const sortedvals = entries
        .map((e) => ({
          ...e,
          order: e.key === "Net" ? Number.MAX_SAFE_INTEGER : 0,
        }))
        .sort((a, b) => a.order - b.order)
        .map(({ order, ...e }) => e);

      const allValues = Object.fromEntries(
        entries.map((e) => [
          e.key,
          { label: e.area_name, value: e.value, lower: e.lower, upper: e.upper },
        ])
      );

      return {
        ...f,
        properties: {
          ...f.properties,
          fillColor,

          // For "top", topKey becomes the winner for this area
          topKey: resolvedHeatKey,
          topLabel: entries[0]?.area_name || "",
          topValue: Number.isFinite(v) ? v : 0,

          topLower: heatCI.lower,
          topUpper: heatCI.upper,

          topBaseline: baseline,
          topPred: heatCI.value,
          topChange: Number.isFinite(v) ? v : 0,

          _allValues: allValues,
          _allValuesSorted: sortedvals,
        },
      };
    }),
  };

  this.setState({ styledGeo: styled, styleLoaded: true });
};

  fitBoundsFromFeatures = (features) => {
  if (!this.mapRef.current || !features?.length) return null;
  const map = this.mapRef.current.getMap();
  const bounds = new mapboxgl.LngLatBounds();
  this.setState({viewState:null})
  features.forEach(f => {
    const coords = f.geometry.type === "Polygon"
      ? f.geometry.coordinates.flat(1)
      : f.geometry.coordinates.flat(2);
    coords.forEach(([lng, lat]) => bounds.extend([lng, lat]));
  });
  map.fitBounds(bounds, { padding: 28, duration: 500 });
  return bounds;
};

  

   onMapClick = (evt) => {
    const feature = evt.features?.[0];
    if (!feature) return;
    const level = this.state.geoLevel;
    const p = feature.properties || {};
    const areaId = String(p.area_id ?? "");
    const map = this.mapRef.current?.getMap();


    const zoomToFeature = (feat) => this.fitBoundsFromFeatures([feat]);

    

    const clickedLevel = level;

    if (
      areaId &&
      this.state.selectedFeature &&
      this.state.selectedFeature.level === clickedLevel &&
      this.state.selectedFeature.area_id === areaId
    ) {
      this.setState({ selectedFeature: null }, () => {
        if (this.state.selectedStateBounds) {
          map?.fitBounds(this.state.selectedStateBounds, { padding: 28, duration: 500 });
        } else {
         // map?.fitBounds([[-125, 24], [-66, 49]], { padding: 20, duration: 500 });
        }

        this.props.onFeatureSelect?.({
          feature: null,
          selectedAreaLabel: null,
          selectedFeatureLevel: null,
        });
      });
      return;
    }

     if (level === "geementen") {
      const constCode = String(p.area_id || "")
      if (!constCode) return;
  
      const stateBounds = zoomToFeature(feature); // sets map to state
      const stateLabel =  p.area_name;
  
      this.setState(
        {
          selectedconstCode: constCode,
          selectedStateBounds: stateBounds,
          geoLevel: "buurt",
          // Keep selectedFeature pointing to the state context
          selectedFeature: {
            level: "geementen",
            key: "gemeentecode",
            area_id: constCode,
            area_name: stateLabel,
            rowMatchIds: [constCode],
          },
        },
        () => {
          // Make sure county metrics (and secondary metrics) are loaded for tooltips
          this.fetchMetrics("buurt",constCode );
          // Load county geo for that state (no auto-fit; we already zoomed)
          this.loadGeo("buurt", { doFit: false });
                
  
        }
      );
      return;
    }


  };

      onMouseMove = (evt) => {
        const feature = evt.features && evt.features[0];
        if (!feature) return this.setState({ hoverInfo: null,hoverAreaId:null });
    
        const { lng, lat } = evt.lngLat; 
        this.setState({
        hoverInfo: { lon: lng, lat, props: feature.properties },
        hoverAreaId: feature.properties.area_id ?? null
        });
    };

  loadGeo = async (level) => {
    let newGeo 
    switch(level){
        case "geementen":
         newGeo = this.props.GEEMENTENMap
        break
        case "buurt":
         newGeo = this.props.BUURTMap
        break
        default:
         newGeo = this.props.GEEMENTENMap
        break
    }
    this.setState({geoData: newGeo, geoLevel: level
    })
  }

 onGeoLevelChange = (newLevel) => {
  if (!newLevel) return;

  // if these are async functions already, await them
  this.fetchMetrics(newLevel, this.state.selectedFeature?.area_id);
  this.loadGeo(newLevel);

  // return when both finish
};
    // Utility: compute bounds [minX, minY, maxX, maxY] from a FeatureCollection
getFeatureCollectionBounds = (featureCollection) => {
  let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;

  featureCollection.features.forEach((feat) => {
    const coords = feat.geometry.coordinates;

    const recurse = (arr) => {
      if (typeof arr[0] === "number") {
        const [x, y] = arr;
        if (x < minX) minX = x;
        if (y < minY) minY = y;
        if (x > maxX) maxX = x;
        if (y > maxY) maxY = y;
      } else {
        arr.forEach(recurse);
      }
    };

    recurse(coords);
  });

  return [[minX, minY], [maxX, maxY]];
};
    

   resetView = ({ LevelToResetTo = "geementen" }) => {
    const map = this.mapRef.current?.getMap();
    if (map) {
    map.fitBounds(
      [
      [3.3, 50.7],  // SW (south-west)
      [7.2, 53.6],  // NE (north-east)
      ],
      { padding: 80 }
    );
  }

  this.setState(
    {
      geoLevel: LevelToResetTo,
      selectedStateCode: null,
      selectedStateBounds: null,
      selectedFeature: null,
      metricRows: null,
      styledGeo: null,
            
    },
    () => {
      this.onGeoLevelChange(LevelToResetTo);

    }
  );
};

handleselectedFeatureChange =  (area_id, area_name) => {

  


    const feature = this.props.GEEMENTENMap.features.filter(
          f => String(f.properties.area_id) === String(area_id.area_id)
        )[0];
    if (!feature) return;
    const level = this.state.geoLevel;
    const p = feature.properties || {};
    const areaId = String(p.area_id ?? "");
    const map = this.mapRef.current?.getMap();

    const zoomToFeature = (feat) => this.fitBoundsFromFeatures([feat]);   

    const clickedLevel = level;


    if (
      areaId &&
      this.state.selectedFeature &&
      this.state.selectedFeature.level === clickedLevel &&
      this.state.selectedFeature.area_id === areaId
    ) {
      this.setState({ selectedFeature: null }, () => {
        if (this.state.selectedStateBounds) {
          map?.fitBounds(this.state.selectedStateBounds, { padding: 28, duration: 500 });
        } else {
         // map?.fitBounds([[-125, 24], [-66, 49]], { padding: 20, duration: 500 });
        }

        this.props.onFeatureSelect?.({
          feature: null,
          selectedAreaLabel: null,
          selectedFeatureLevel: null,
        });
      });
      return;
    }
      const stateBounds = zoomToFeature(feature); // sets map to state

      const constCode = String(p.area_id || "")
      if (!constCode) return;
  
      const stateLabel =  p.area_name;
  
      this.setState(
        {
          selectedconstCode: constCode,
          selectedStateBounds: stateBounds,
          geoLevel: "buurt",
          viewState:null,
          // Keep selectedFeature pointing to the state context
          selectedFeature: {
            level: "geementen",
            key: "gemeentecode",
            area_id: constCode,
            area_name: stateLabel,
            rowMatchIds: [constCode],
            
          },
        },
        () => {
          // Make sure county metrics (and secondary metrics) are loaded for tooltips
          this.fetchMetrics("buurt",constCode );
          // Load county geo for that state (no auto-fit; we already zoomed)
          this.loadGeo("buurt", { doFit: false });
                
  
        }
      );
      return;
    
 

}
  handlechosenPartyChange     = (val) => this.setState({ chosenParty: val });
  handlechosenViewChange     = (val) => this.setState({ chosenView: val });

  onIssueLevelChange = (newLevel) => {
  if (!newLevel) return;

  const keys = getIssueKeys(newLevel);

  // Work out the "base" concept from whatever is currently selected
  // e.g. "past_vote_turnout" -> "turnout"
  //      "turnout_GE_p"      -> "turnout"
  //      "D66_LE_p"          -> "D66"
  const base = this.getBaseGroup(this.state.chosenParty);

  // Build the equivalent key at the new level
  const mapped = base ? this.buildGroupKey(base, newLevel) : null;

  // Prefer the mapped key; otherwise fall back sensibly
  const nextChosen =
    (mapped && keys.includes(mapped)) ? mapped :
    keys.includes(this.state.chosenParty) ? this.state.chosenParty :
    keys[0];

  this.setState({
    IssueLevel: newLevel,
    chosenParty: "top",
  });
};

 getBaseGroup(chosenKey) {
  if (!chosenKey) return null;

  // past: "past_vote_X"
  if (chosenKey.startsWith("past_vote_")) {
    return chosenKey.replace("past_vote_", "");
  }

  // GE/LE: "X_GE_p" or "X_LE_p" (including turnout_GE_p, OtherRight_GE_p etc.)
  // base is everything before the first underscore
  // (works with your current naming scheme)
  return chosenKey.split("_")[0];
}
     


buildIssueBarData = () => {
  const { IssueLevel, selectedFeature, metricRowsConst } = this.state;

  // Decide which metric rows to use:
  // - If a feature is selected, search in metricRows for its area_id
  // - Otherwise, use the national summary row (your existing behaviour)
  let row = null;
  
  console.log("selectedFeature",selectedFeature)

  if (selectedFeature?.area_id) {
    const targetId = String(selectedFeature.area_id);

    // metricRows are the per-area rows (e.g. municipalities)
    row =
      (metricRowsConst || []).find((r) => String(r.area_id) === targetId) ||
      null;
  }

  // Fallback to the national row if no selection or no match found
  if (!row) {
    row = this.state.metricRowsNational?.[0] || null;
  }

  if (!row) return [];

  // Normalise IssueLevel (you said you use "national"/"local")
  const level = IssueLevel === "local" ? "local" : "national";
  const suffix = level === "local" ? "_local_p" : "_nat_p";

  const data = Object.keys(ISSUE_INFO)
    .filter((k) => k.endsWith(suffix) && k in row)
    .map((k) => {
      const fullName = ISSUE_INFO[k]?.name ?? k;
      const shortName = fullName
        .replace(/\s*\(national\)\s*/i, "")
        .replace(/\s*\(local\)\s*/i, "")
        .trim();

      return {
        key: k,
        name: shortName,
        shortName,
        value: Number(row[k]),
        color: ISSUE_INFO[k]?.color ?? "#6e6e6e",
      };
    })
    .filter((d) => Number.isFinite(d.value) && d.value > 0)
    .sort((a, b) => b.value - a.value);

  return data;
};



 renderIssueBarChart = () => {
  const data = this.buildIssueBarData();
  if (!data.length) return null;

  return (
    <Box sx={{ width: "100%", height: "100%", minHeight: 0 }}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={data}
          layout="vertical"
          margin={{ top: 8, right: 18, left: 8, bottom: 8 }}
        >
          <CartesianGrid horizontal={false} />
          <XAxis type="number" hide tickLine={false} axisLine={false} />
          <YAxis type="category" dataKey="name" width={160} tickLine={false} axisLine={false} />
          <Tooltip cursor={{ fill: "rgba(0,0,0,0.04)" }} content={<IssueTooltip />} />
          <Bar
            dataKey="value"
            isAnimationActive={false}
            radius={[0, 10, 10, 0]}
            barSize={25}
          >
            {data.map((d) => (
              <Cell key={d.key} fill={d.color} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </Box>
  );
};





 buildGroupKey(base, IssueLevel) {
  if (IssueLevel === "past") {
    return `past_vote_${base}`;
  }

  const level = IssueLevel === "local" ? "local" : "national";
  return `${base}_${level}_p`;
}

  render() {
    const partyKeys = getIssueKeys(this.state.IssueLevel);

  return(
    <>
  <Box sx={{ height: "92vh", display: "flex", flexDirection: "column", width:'100%' }}>
    {/* HEADER (auto height, no flexGrow) */}
    <Box
      sx={(theme) => ({
        px: 3, py: 3,
        display: "flex", alignItems: "center",
        backgroundColor: theme.vars
          ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
          : theme.palette.background.default,
        borderBottom: `1px solid ${theme.palette.divider}`,
        // no flexGrow, no % height here
      })}
    >
      {/* left: icon + text */}
      <Stack direction="row" spacing={2} alignItems="center" sx={{ ml: 4 }}>
        <Avatar
          variant="square"
          src={`${process.env.PUBLIC_URL}/static/images/logo.png`}
          alt="Projected Vote Shares"
          sx={{
            width: 44, height: 44, flexShrink: 0,
            bgcolor: "transparent",
            "& .MuiAvatar-img": { objectFit: "contain" },
          }}
        />
        <Box>
          <Typography variant="h5" fontWeight={700}>Projected Vote Shares</Typography>
          <Typography variant="body1" color="text.secondary">
            Select a party from the list below to display their heat maps
          </Typography>
        </Box>
      </Stack>

{/* right: selects */}
<Stack direction="row" alignItems="center" spacing={2} sx={{ ml: "auto", pr: 4 }}>
  <TextField
    select
    label="Display:"
    size="small"
    value={this.state.chosenParty}
    onChange={(e) => this.handlechosenPartyChange?.(e.target.value)}
    sx={{ minWidth: 180 }}
  >
    {["top", ...partyKeys].map((key) => (
      <MenuItem key={key} value={key}>
        {key === "top" ? "Top" : (ISSUE_INFO[key]?.name ?? key)}
      </MenuItem>
    ))}
  </TextField>
{/*
                    <TextField
                    select
                    label="View"
                    size="small"
                    value={this.state.chosenView}
                    onChange={(e) => this.handlechosenViewChange?.(e.target.value)}
                    sx={{ minWidth: 180 }}
                    >
                    <MenuItem value="pred">Predicted vote share</MenuItem>
                    <MenuItem value="change">Change since 2025</MenuItem>
                    </TextField>

*/}
      </Stack> 
    </Box>

    {/* CONTENT: fills the rest, split 50/50 */}
    <Box
      sx={{
        flex: 1,
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        overflow: "hidden",
        height: "100%",
        width:"100%"
      }}
    >
      {/* LEFT PANEL (map) */}
      <Box sx={{ minWidth: 0, overflow: "hidden" }}>
        <Box sx={{ width: "100%", height: "100%" }}>
          <MapComponent
            mapRef={this.mapRef}
            styledGeo={this.state.styledGeo}
            geoData={this.state.geoData}
            hoverInfo={this.state.hoverInfo}
            styleLoaded={this.state.styleLoaded}
            selectedFeature={this.state.selectedFeature}
            onMapClick={this.onMapClick}
            onMouseMove={this.onMouseMove}
            IssueLevel={this.state.IssueLevel}
            onIssueLevelChange={this.onIssueLevelChange}
            onGeoLevelChange={this.onGeoLevelChange}
            buildLabelsAndColors={buildLabelsAndColors}
            geoLevel={this.state.geoLevel}
            resetView={this.resetView}
            handleselectedFeatureChange={this.handleselectedFeatureChange}
            viewState={this.state.viewState}
            tooltip = {"Issues"}
            chosenView = {this.state.chosenView}
            chosenParty = {this.state.chosenParty}
            maptype="issues"
          />
        </Box>
      </Box>

      {/* RIGHT PANEL */}
<Box
  sx={{
    minWidth: 0,
    borderLeft: 1,
    borderColor: "divider",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden", // IMPORTANT: don't let children define height
  }}
>
  {/* if you later add a title/controls above the chart, they go here */}
  <Box sx={{ flex: 1, minHeight: 0 }}>
    {this.renderIssueBarChart()}
  </Box>
</Box>
    </Box>
  </Box>
</>

  )
}


  }

export default withRouter(NZ2026SeatComparisonIssues);